import { ColumnLabel } from "../Layout/ColumnLabel"
import Modal from "../Modal/Modal"

export type CardFilterInstructionModalProps = {
    isOpen: boolean,
    setIsOpen: (isOpen: boolean) => void
}

export function CardFilterInstructionModal(props: CardFilterInstructionModalProps) {
    return (
        <Modal
            isOpen={props.isOpen}
            onOpenChange={(isOpen) => props.setIsOpen(isOpen)}
            classNames={{ mainContainer: "pt-8", dialogPanel: "!max-w-lg" }}
        >
            <div className="text-sm flex flex-col gap-6">
                <Instruction
                    label="Strict Match"
                    instruction='Wrap text in double quotes to force exact matching.'
                    example='"Warrior"' />

                <Instruction
                    label="Exclude"
                    instruction='Add an exclamation mark to the beginning of the search term to exclude cards matching that phrase from the results.'
                    example='!Warrior of Light' />

                <Instruction
                    label="Search Multiple Values"
                    instruction='Separate terms with a semicolon to search multiple terms at once.'
                    example='freeze;discard' />

                <Instruction
                    label="Mix and Match"
                    instruction='Combine these together for flexible searching.'
                    example='Warrior;!Warrior of Light' />
            </div>
        </Modal>
    )
}

function Instruction(props: {
    label: string,
    instruction: string,
    example: string
}) {
    return (
        <div>
            <div className="font-semibold">{props.label}</div>
            <div>
                <div>{props.instruction}</div>
                <div className="text-contrast-tertiary">{props.example}</div>
            </div>
        </div>
    )
}